import { FC, MouseEventHandler } from 'react';

import { Icon, IconName } from '@purpur/library/icon';
import { arrowRight } from '@purpur/library/icon/assets/arrow-right';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { getSvgIcon } from '@telialt/common-icon/src';
import { useComponentId } from '@telialt/utils/src/hooks';

import {
    ServiceCardCta,
    ServiceCardDescription,
    ServiceCardDescriptionContainer,
    ServiceCardIcon,
    ServiceCardTitle,
    ServiceCardTitleSection,
    ServiceCardWrapper,
} from './ServiceCard.styles';

type Props = {
    variant: 'minimal' | 'full';
    title: string;
    description?: string;
    url: string;
    icon?: IconName;
    dataTest?: string;
    onClick?: MouseEventHandler<HTMLAnchorElement>;
};

export const ServiceCard: FC<Props> = ({ variant, title, description, url, icon, dataTest, onClick }) => {
    const { t } = useTranslations();
    const cardId = useComponentId();

    return (
        <ServiceCardWrapper
            href={url}
            onClick={onClick}
            $variant={variant}
            data-test={dataTest}
            aria-labelledby={cardId}
        >
            <ServiceCardTitleSection>
                {icon && <ServiceCardIcon svg={getSvgIcon(icon)} />}
                <ServiceCardTitle variant={variant === 'full' ? 'title-100' : 'subsection-100'} tag="h3" id={cardId}>
                    {title}
                </ServiceCardTitle>
            </ServiceCardTitleSection>
            <ServiceCardDescriptionContainer>
                <ServiceCardDescription>{description}</ServiceCardDescription>
            </ServiceCardDescriptionContainer>
            {variant === 'full' && (
                <ServiceCardCta>
                    <span>{t['search.component.service_card.read_more']}</span> <Icon size="xs" svg={arrowRight} />
                </ServiceCardCta>
            )}
        </ServiceCardWrapper>
    );
};
